import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import Select from 'react-select'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { textureOptions } from './constants'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const TofuPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Texture: item.Texture,
    PackageSize: item.PackageSize,
    Organic: item.Organic,
  })
  const methods = useFormContext()
  const {
    onChangeReviewer,
    setSwitchReviewer,
    setSelectReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item) {
      const { Texture, PackageSize, Organic } = item
      setPackaging({
        Texture,
        PackageSize,
        Organic,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Texture {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={textureOptions}
            defaultValue={{
              label: packaging.Texture,
              value: packaging.Texture,
            }}
            name="Texture"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Texture'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                Texture: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Texture"
              message={'⚠ Please select a texture.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item.Texture === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Texture (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="OtherTexture"
                placeholder={'Other Texture'}
                defaultValue={item.OtherTexture}
                control={methods.control}
                rules={{ required: true }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key) && e.key !== ' ') {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="OtherTexture"
                  message={'Other Texture is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Package Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="PackageSize"
            type="number"
            step="0.01"
            placeholder={'14 - 16 ounces'}
            defaultValue={packaging.PackageSize}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
              min: {
                value: 14,
                message: '⚠ Size is below the required 14 ounce minimum.',
              },
              max: {
                value: 16,
                message: '⚠ Size exceeds the 16 ounces allowed.',
              },
              required: {
                value: true,
                message: '⚠ Please enter product size.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="PackageSize"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.Organic}
            disabled={isDisabled}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

TofuPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default TofuPackageReview
